"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_session_store_1 = require("owa-session-store");
function isMessagePreviewEnabled() {
    return owa_session_store_1.getUserConfiguration().UserOptions.ShowPreviewTextInListView;
}
exports.default = isMessagePreviewEnabled;
//# sourceMappingURL=isMessagePreviewEnabled.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-preview-option/lib/utils/isMessagePreviewEnabled.js
// module id = 5112
// module chunks = 2